import React, { useState } from "react";
import Card from "components/card";
import Modal from "components/modal/Modal";
import imagePlaceholder from "assets/img/avatars/avatar9.png";
import { MdModeEditOutline } from "react-icons/md";
import { BsExclamationDiamond } from "react-icons/bs"
import { useFuncionarios, Funcionario } from "context/FuncionarioContext";

export default function Users() {
  const { funcionarios, editarFuncionario, removerFuncionario } = useFuncionarios();
  const [selectedFuncionario, setSelectedFuncionario] = useState<Funcionario | null>(null);
  const [selectedDetalhes, setSelectedDetalhes] = useState<Funcionario | null>(null);
  const [newNome, setNewNome] = useState("");

  const handleOpenModal = (func: Funcionario) => {
    setSelectedFuncionario(func);
    setNewNome(func.nome);
  };

  const handleOpenModalDetalhes = (func: Funcionario) => {
    setSelectedDetalhes(func);
  };

  const handleSaveNome = () => {
    if (selectedFuncionario) {
      editarFuncionario(selectedFuncionario.id, newNome);
      setSelectedFuncionario(null);
    }
  };

  const handleRemove = (id: string) => {
    removerFuncionario(id);
  };

  return (
    <Card extra="w-full p-4 h-full">
      <div className="mb-8 w-full">
        <h4 className="text-xl font-bold text-navy-700">Funcionários</h4>
        <p className="mt-2 text-base text-gray-600">
          Lista de funcionários cadastrados nas unidades.
        </p>
      </div>

      {funcionarios.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-10 text-gray-500">
          <div className="mt-2 flex items-center justify-center rounded-full bg-lightPrimary p-[26px] text-5xl font-bold text-[#CF4949]">
            <BsExclamationDiamond />
          </div>
          <h3 className="text-xl font-bold text-navy-700 my-3">Nada Aqui</h3>
          <p className="text-center text-sm text-gray-600 px-4">
            Nenhum funcionário adicionado ainda.
          </p>
        </div>
      ) : (
        funcionarios.map((func) => (
          <div
            key={func.id}
            className="mt-3 flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 border-gray-200"
          >
            <div className="flex items-center">
              <img
                className="h-[83px] w-[83px] rounded-lg"
                src={func.foto || imagePlaceholder}
                alt="Foto Funcionário"
              />
              <div className="ml-4">
                <p className="text-base font-medium text-navy-700">
                  {func.nome}
                </p>
                <p className="mt-2 text-sm text-gray-600">
                  {func.unidadeName} ·{" "}
                </p>
                <span
                  className="ml-1 font-medium text-brand-500 hover:text-brand-500 cursor-pointer"
                  onClick={() => handleOpenModalDetalhes(func)}
                >
                  Mais detalhes
                </span>
              </div>
            </div>

            <div className="flex gap-3 items-center">
              <button
                onClick={() => handleOpenModal(func)}
                className="text-gray-600"
              >
                <MdModeEditOutline />
              </button>

            </div>
          </div>
        ))
      )}

      {/* Modal de Detalhes */}
      {selectedDetalhes && (
        <Modal onClose={() => setSelectedDetalhes(null)}>
          <h2 className="text-lg font-bold mb-2">Detalhes do Funcionário</h2>
          <p>Nome: {selectedDetalhes.nome}</p>
          <p className="text-sm mb-4">
            Unidade: {selectedDetalhes.unidadeName} <br />
            Data de Cadastro: {selectedDetalhes.dataCadastro} <br />
            Hora de Cadastro: {selectedDetalhes.horaCadastro}
          </p>
          <button
            onClick={() => {
              handleRemove(selectedDetalhes.id);
              setSelectedDetalhes(null);
            }}
            className="mt-2 px-3 py-1 bg-[#CF4949] font-bold text-white transition duration-200 hover:bg-[#B84343] active:bg-[#B84343] rounded"
          >
            Excluir Funcionário
          </button>
        </Modal>
      )}

      {/* Modal de Edição */}
      {selectedFuncionario && (
        <Modal onClose={() => setSelectedFuncionario(null)}>
          <h2 className="text-lg font-bold mb-2">Editar Nome do Funcionário</h2>
          <input
            className="w-full border rounded p-2 mb-4"
            value={newNome}
            onChange={(e) => setNewNome(e.target.value)}
          />
          <button
            className="mt-2 px-3 py-1 bg-[#CF4949] font-bold text-white transition duration-200 hover:bg-[#B84343] active:bg-[#B84343] rounded"
            onClick={handleSaveNome}
          >
            Salvar Alterações
          </button>
        </Modal>
      )}
    </Card>
  );
}
